import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

const columns = [
    ['Example link', 'Example link', 'Example link', 'Example link', 'Example link'],
    ['Example link', 'Example link', 'Example link', 'Example link', 'Example link'],
    ['Example link', 'Example link', 'Example link', 'Example link', 'Example link'],
];

export function MegaMenu() {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="text-sm font-medium text-white hover:text-white">
                Mega Menu
            </Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Menu.Items
                    className="
            absolute left-0 mt-2 origin-top-left
            bg-white text-gray-800 shadow-lg rounded-md
            ring-1 ring-black/10 focus:outline-none
            z-50
            w-max max-w-[640px]
            p-6
          "
                >
                    <div className="flex w-full">
                        {/* Three equal columns */}
                        {columns.map((col, i) => (
                            <div key={i} className="flex-1 pl-4">
                                <ul className="space-y-3">
                                    {col.map((link, j) => (
                                        <li key={j} className="flex items-start">

                                            <a
                                                href="#"
                                                className="text-sm text-gray-700 hover:text-blue-600"
                                            >
                                                {link}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}
